const EMAIL_SETTINGS = {
  EMAIL_HEADER: 'Email Settings',
  EMAIL_SUBTITLE:
    'This section is for sending email settings for offline responses, so that when a user sends a message to your website and your support team is not online if he has registered his email after the operator replies, an email with the following settings will be sent to the user.',
  EMAIL_SWITCH_LABEL: 'Send email to users',
  EMAIL_SWITCH_GUIDE: 'Send email or not',
  EMAIL_TITLE_LABEL: 'The title of sent emails',
  EMAIL_TITLE_GUIDE: 'Title of the email',
  EMAIL_TITLE_INPUT_PLACEHOLDER: 'Example: --operator-- from --channelName--',
};

export default EMAIL_SETTINGS;
